import { usePage } from '@inertiajs/react';
import { useCallback } from 'react';

type Translations = Record<string, unknown>;

interface PagePropsWithTranslations {
    translations?: Translations;
    [key: string]: unknown;
}

const emptyTranslations: Translations = Object.freeze({});

export function useTranslations() {
    const page = usePage<PagePropsWithTranslations>();
    const translations = page.props.translations ?? emptyTranslations;

    const t = useCallback(
        (key: string, fallback?: string): string => {
            if (!key) {
                return fallback ?? '';
            }

            const segments = key.split('.');
            let current: unknown = translations;

            for (const segment of segments) {
                if (current == null || typeof current !== 'object' || !(segment in current)) {
                    return fallback ?? key;
                }
                current = (current as Record<string, unknown>)[segment];
            }

            if (typeof current === 'string') {
                return current;
            }

            return fallback ?? key;
        },
        [translations],
    );

    return { t };
}
